export default __webpack_public_path__ + "cd4827f46eedc6c67f4a3af4d300cf32.png";